import {
	AfterContentInit,
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	ContentChildren,
	ElementRef,
	Input,
	OnInit,
	QueryList,
	ViewChild,
} from "@angular/core";

@Component({
	standalone: false,
	selector: "ay-page-main",
	templateUrl: "./ay-page-main.component.html",
	styleUrls: ["./ay-page-main.component.scss"],
})
export class AyPageMainComponent implements AfterViewInit {
	@ViewChild("sideBar") sideBar: ElementRef;
	@Input() showAside: boolean = true;
	@Input() stickyAside: boolean = true;

	constructor(private cdRef: ChangeDetectorRef) {}

	ngAfterViewInit() {
		if (!this.sideBar?.nativeElement.children.length) {
			this.showAside = false;
		}
		this.cdRef.detectChanges();
	}
}
